import React from 'react'
import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'
import { Leaderboard } from '@trivie/ui-mobile/components/leaderboard'

export const DailyLeaderboardTab = observer((props: any) => {
  const { selectedTag, load } = props
  const { rootCache, leaderboardStore } = useStores()
  const { loadingDaily, dailyUserLeaderboard, tagLeaderboard } = leaderboardStore

  const refresh = () => {
    rootCache.invalidateAction('getLeaderboards', leaderboardStore)
    rootCache.invalidateAction('getLeaderboardRank', leaderboardStore)
    load('daily')
  }

  return (
    <Leaderboard
      refresh={refresh}
      data={
        selectedTag !== '' && selectedTag !== 'User'
          ? tagLeaderboard.filter((tag: any) => tag.rank != null)
          : dailyUserLeaderboard
      }
      loading={loadingDaily}
      selectedTag={selectedTag}
    />
  )
})
